;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import './button.scss';
import Link from "next/link";
import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'inline';
    link: string;
}

export default function Button({className, link, variant, children, ...props}: Props) {
    return (
        <Link href={link}>
            <button className={`button -${variant} ${className}`} {...props}>
                <span className="content">{children}</span>
            </button>
        </Link>
    )
}
